import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import type { RootState } from "../../../Reducers/RootReducer";

import ConfigurableReportingListener from "./ConfigurableReportingListener";

export const MessageListener = (): JSX.Element => {
    const dispatch = useDispatch();
    const history = useHistory();

    const reportState = useSelector((state: RootState) => state.reports);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            // If more "channels" are needed, this should be converted to a switch statement on event.data.channel
            if (event.data && event.data.channel === "CONFIGURABLE_REPORTING") {
                ConfigurableReportingListener(dispatch, history, event, reportState);
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [dispatch, history, reportState]);

    return <></>;
};